'use es6';

export const REASSIGN = 'REASSIGN';
export const CLOSE = 'CLOSE';